<template>
  <q-dialog
    v-model="showDialog"
    maximized
    data-test-id="order-filter-by-model-dialog"
  >
    <q-card>
      <div class="row q-ml-sm items-center q-gutter-sm">
        <div
          class="col row justify-start items-center"
          style="flex-grow: 1"
        />
        <div
          class="col row justify-end"
          style="flex-grow: 1"
        >
          <q-btn
            icon="close"
            flat
            round
            dense
            @click="showDialog = false"
          />
        </div>
      </div>
      <q-card-section class="column items-center">
        <order-table
          style="max-width: 100%"
          :showing-id="showingId"
          :gift-card-id="giftCardId"
          :voucher-id="voucherId"
          :user-id="userId"
          @edit="order => { $emit('select-order', order); showDialog = false }"
          @select-order="order => { $emit('select-order', order); showDialog = false }"
          @request-authorization="callback => $emit('request-authorization', callback)"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

import OrderTable from 'src/modules/admin/order/OrderTable'

export default {
  name: 'OrderFilterByModelDialog',
  components: {
    OrderTable
  },
  emits: ['select-order', 'request-authorization'],
  data () {
    return {
      showDialog: false,
      showingId: null,
      giftCardId: null,
      voucherId: null,
      userId: null
    }
  },
  methods: {
    async show (showingId, voucherId, giftCardId, userId) {
      this.showingId = showingId
      this.giftCardId = giftCardId
      this.voucherId = voucherId
      this.userId = userId
      this.showDialog = true
    }
  }
}
</script>
